import React from 'react';
import CareerGraph from './CareerGraph';
import { Section } from './ui';

const Experience: React.FC = () => (
  <Section
    id="experience"
    index="01"
    eyebrow="Experience"
    title={
      <>
        Where I’ve <em className="text-accent">shipped</em>.
      </>
    }
  >
    <CareerGraph />
  </Section>
);

export default Experience;
